<template>
  <div class="favorite">
    <div class="container mt-5">
      <section class="bg white mt-sm-5 mt-3">
        <h3
          class="ui header large-lg medium-md small black pt-4 pb-4 px-lg-5 px-md-3 px-2 mb-0 text-center"
        >{{$t('MyFavorite')}}</h3>
        <hr class="gray-7 mt-0">
        <div v-if="products.length == 0" class="p-lg-5 p-2">
          <div class="row justify-content-center">
            <div class="col-lg-2 col-md-3 col-sm-4 col-6">
              <img src="../assets/img/icon-heart-plus.svg">
            </div>
          </div>
          <p
            class="ui header semibold medium-lg small-md mini light color gray-7 mt-3 text-center"
          >{{$t('NotFavorite')}}</p>
          <div class="row justify-content-center">
            <router-link to="/" exact class="ui button teal text large">
              <span class="ui text large">
                <i class="icon-custom-shop mr-2"></i>
                {{$t('NowShop')}}
              </span>
            </router-link>
          </div>
        </div>
        <div v-else class="p-lg-5 p-2">
          <div class="row">
            <div v-for="(product, index) in products" :key="index" class="col-md-3 col-sm-4 col-6">
              <div class="product type-fav mb-3 mt-3">
                <div
                  @click="removeProduct(product.id)"
                  class="product__remove circular basic ui icon button"
                >
                  <i class="close icon"></i>
                </div>
                <h5 class="ui text big-lg medium-md tiny-sm small semibold text-truncate">
                  <router-link :to="'products/item/'+product.id">{{product.titleTH}}</router-link>
                </h5>
                <div class="thumb">
                  <router-link :to="'products/item/'+product.id">
                    <img
                      v-if="product.images[0]"
                      :src="[ product.images[0].filename ]"
                    >
                    <img v-else src="../assets/img/default-noimg.png">
                  </router-link>
                </div>
                <div class="d-flex align-items-center mt-3">
                  <div class="price">
                    <p
                      class="ui text big-lg medium-md tiny-sm small bold [ color red-2 ] m-0"
                    >{{currency}}{{formatPrice(product.netPrice)}}</p>
                    <p
                      v-if="product.netPrice != product.price"
                      class="ui text big-lg medium-md tiny-sm small light line-through m-0"
                    >{{currency}}{{formatPrice(product.price)}}</p>
                  </div>
                  <div class="d-flex align-items-center ml-auto">
                    <AddToCart
                      v-if="product.quantity != 0"
                      :btnStyle="'style1'"
                      :product="product"
                    />
                    <span v-else class="badge badge-danger mr-2">{{$t('SoldOut')}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

import AddToCart from "@/components/cart/AddItem.vue";
export default {
  name: "favorite",
  components: {
    AddToCart
  },
  data() {
    return {
      loading: true,
      products: [],
      login: false
    };
  },
  created() {
    this.getFavorite();
  },
  methods: {
    getFavorite() {
      this.$http
        .get("favorite")
        .then(response => {
          this.products = response.data.data;
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false));
    },
    removeProduct(id) {
      this.$http
        .delete("favorite/" + id)
        .then(response => {
          this.getFavorite();
        })
        .catch(error => console.log(error))
        .finally(() => (this.loading = false));
    },
    formatPrice(value) {
      let price = Number(value);
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>
<style lang="scss">
.product.type-fav {
  border: 1px solid rgba(0, 0, 0, 0.1) !important;
}
</style>

